import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'projects/registro-personas-empresas/src/environments/environment';
import { Observable } from 'rxjs';
import { Sexo } from './entity-sexo.model';

@Injectable({ providedIn: 'root' })
export class SexoService {
  endpoint = 'tiposIdentidadGenero';

  constructor(private http: HttpClient) {}

  getAll(): Observable<Sexo[]> {
    return this.http.get<Sexo[]>(`${environment.apiUrl}/${this.endpoint}/`);
  }
}
